export default __webpack_public_path__ + "static/media/ic_history-sync.6c38ece7.svg";